
export const KYB_ENDPOINTS = {
  addKybInformationUpdate: ({ businessId }: { businessId: string, }) => `/v1/admin/business-information-requests/business/${businessId}/information-update`,
  addKybInformation: ({ businessId }: { businessId: string, }) => `/v1/admin/business-information-requests/business/${businessId}/additional-information`,
  getBusinessCatalogue: (businessId: string) => `/v1/admin/business-information-requests/catalog?businessId=${businessId}`,
  approveSubmittedKyb: ({ businessId }: { businessId: string, }) => `/v1/admin/review-submission/${businessId}`,
}